import { cn } from '@shared/utils/utils';
import { CHANNELS_WITH_FILE_IMPORT, type ShopsModel } from '../../models/Shops';

const AMAZON_FBM_CHANNEL_ID = CHANNELS_WITH_FILE_IMPORT[0];

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

const wrapperClass: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'w-6 h-6 rounded-full flex items-center justify-center overflow-hidden border border-card-border text-text bg-card-border',
  md: 'w-8 h-8 bg-transparent rounded-full flex items-center justify-center overflow-hidden border border-card-border text-text',
  lg: 'w-16 h-16 bg-card-border rounded-full flex items-center justify-center overflow-hidden border border-lines text-text',
};

const fbmTextClass: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'text-[7px] font-bold leading-none tracking-tight text-foreground',
  md: 'text-[9px] font-bold leading-none tracking-tight text-foreground',
  lg: 'text-sm font-bold leading-none tracking-tight text-foreground',
};

const initialsClass: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'text-black text-xs font-bold',
  md: 'text-black text-xs font-bold',
  lg: 'text-black text-xs font-bold',
};

export interface ShopAvatarProps {
  shop: ShopsModel;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Avatar de tienda: Amazon FBM muestra "FBM"; resto imagen o iniciales del nombre.
 */
export function ShopAvatar({ shop, size = 'md', className }: ShopAvatarProps) {
  const isAmazonFbm = shop.channel_id === AMAZON_FBM_CHANNEL_ID;

  return (
    <div className={cn(wrapperClass[size], className)}>
      {isAmazonFbm ? (
        <span className={fbmTextClass[size]}>FBM</span>
      ) : shop.image ? (
        <img src={shop.image} alt={shop.name} className="h-full w-full object-cover" />
      ) : (
        <span className={initialsClass[size]}>{getInitials(shop.name)}</span>
      )}
    </div>
  );
}
